import React, { Suspense } from "react";
import { UserData } from "../AppRoutes";
import { Navigate, Route, Routes } from "react-router-dom";

interface plcProps {
  setIsAuthenticated: React.Dispatch<React.SetStateAction<UserData | null>>;
}

const MainPage = React.lazy(() => import("../../pages/main-pages/MainPage"));

const Events = React.lazy(
  () => import("../../pages/main-pages/plc/events/list/EventList"),
);

const Master = React.lazy(
  () => import("../../pages/main-pages/plc/master/Master"),
);

const Teams = React.lazy(
  () => import("../../pages/main-pages/plc/teams/list/TeamsList"),
);

const Reports = React.lazy(
  () => import("../../pages/main-pages/plc/reports/Reports"),
);

const Winners = React.lazy(
  () => import("../../pages/main-pages/plc/winners/list/WinnersList"),
);

const PLCRoutes: React.FC<plcProps> = ({ setIsAuthenticated }) => {
  return (
    <Suspense fallback={<div>...Loading</div>}>
      <Routes>
        <Route
          path="/"
          element={<MainPage setIsAuthenticated={setIsAuthenticated} />}
        >
          <Route index element={<Navigate to="events" replace />} />
          <Route path="events" element={<Events />} />
          <Route path="master" element={<Master />} />
          <Route path="teams" element={<Teams />} />
          <Route path="reports" element={<Reports />} />
          <Route path="winners" element={<Winners />} />
        </Route>
      </Routes>
    </Suspense>
  );
};

export default PLCRoutes;
